<div class="app-checkbox-container"
     [class.disabled]="disabled"
     [class.reverse]="reverse">

  <div class="checkbox-wrapper">
    <input
      type="checkbox"
      [id]="id"
      [checked]="value"
      [disabled]="disabled"
      [indeterminate]="indeterminate"
      (change)="onInputChange($event)"
      class="checkbox-input"
      [class.checkbox-small]="size === 'small'"
      [class.checkbox-medium]="size === 'medium'"
      [class.checkbox-large]="size === 'large'"
      [class.checkbox-primary]="color === 'primary'"
      [class.checkbox-success]="color === 'success'"
      [class.checkbox-warning]="color === 'warning'"
      [class.checkbox-danger]="color === 'danger'"
    />
    <label
      [for]="id"
      class="checkbox-box"
      [class.checkbox-checked]="value"
      [class.checkbox-indeterminate]="indeterminate"
    >
      <span class="checkbox-icon" *ngIf="value && !indeterminate"></span>
      <span class="checkbox-indeterminate-icon" *ngIf="indeterminate"></span>
    </label>
  </div>

  <label
    *ngIf="label"
    [for]="id"
    class="checkbox-label"
    (click)="onLabelClick(); $event.preventDefault()"
  >
    {{ label | translate }}
  </label>
</div>
